import React from 'react'
import { ScoresRow } from './weekStyles'
import type { EventGQL } from '../../../../Api'
import { Team } from './team'
import { GameAction } from '../../../../Components/Buttons/GameAction'
import { getBroadcastImg, getGameTimeLocal } from '../../../../Utils'
import { BROADCASTER_LINKS } from '../../../../Config/config'
import { BroadcastCon } from '../../../Schedule/components/weekBox/weekStyles'
import { Lk } from '../../../../Components/Links/Lk'

type TeamsColParams = {
  event: EventGQL
}

export const TeamsCol: React.FC<React.PropsWithChildren<TeamsColParams>> = ({
  event,
}) => {

  return (
    <ScoresRow>
      <Team team={event.awayTeam} event={event} score={event.visitorScore} />
      <div className="gameCol">
        {event.eventStatus === 0 && (
          <div className="gameTime">{`${getGameTimeLocal(event.startTime)}`}</div>
        )}
        {event.eventStatus < 1 && (
          <BroadcastCon>
            <Lk link={event.urlStreaming || BROADCASTER_LINKS.generalESPNPlus} alt="Broadcast">
              {getBroadcastImg(event.broadcaster).map((img, idx) => (
                <img key={idx} className="broadcaster" src={img} alt="" />
              ))}
            </Lk>
          </BroadcastCon>
        )}
        {event.eventStatus === 1 && <div className="live">Live</div>}
        {event.eventStatus >= 2 && event?.period <= 4 && (
          <div className="statusText">Final</div>
        )}
        {event.eventStatus >= 2 && event?.period > 4 && (
          <div className="statusText">Final OT</div>
        )}
        {event.awayTeam && <GameAction event={event} section={'scores'} />}
      </div>
      <Team team={event.homeTeam} event={event} score={event.homeScore} />
    </ScoresRow>
  )
}
